/* AstaLab 2.0 — /login (obiettivo 3). Stessa pagina, stessa logica, sia sopra
   SupabaseBackendAdapter (deploy reale) sia sopra ArtifactDemoBackendAdapter
   (Artifact): non contiene alcun controllo su quale adapter è attivo. */
import { escapeHtml } from "../components/escapeHtml.js";
import { renderNoticeIfAny } from "../components/DemoModeBanner.js";

// Round Beta-P3-3 (design D4, accettato): generazione modulo-privata, mai condivisa con
// RegisterPage.js o altre pagine — incrementata a OGNI renderLoginPage(), che sia per un cambio di
// route o un ritorno sulla STESSA route (§15 del design D2: l'uguaglianza dell'hash da sola non
// basta a riconoscere un vecchio render abbandonato che rientra sulla stessa destinazione).
let _loginRenderGeneration = 0;

export function renderLoginPage(container, ctx){
  const myGeneration = ++_loginRenderGeneration;
  const hashAtEntry = window.location.hash;
  // Vero se: (a) un render PIÙ RECENTE di questa stessa pagina è già iniziato (stesso o diverso
  // hash — copre il rientro sulla stessa route), OPPURE (b) l'hash è cambiato (copre la partenza
  // verso una route diversa). Nessuna delle due condizioni da sola basta (D2 §9/§15).
  function isStale(){
    return myGeneration !== _loginRenderGeneration || window.location.hash !== hashAtEntry;
  }
  container.innerHTML =
    '<div class="auth-card">' +
      '<h1>Accedi ad AstaLab</h1>' +
      '<form id="loginForm">' +
        '<label class="field">Email<input type="email" id="loginEmail" required autocomplete="email"></label>' +
        '<label class="field">Password<input type="password" id="loginPassword" required autocomplete="current-password"></label>' +
        '<button type="submit" class="btn primary">Accedi</button>' +
      '</form>' +
      '<div id="loginMsg"></div>' +
      '<p class="hint"><a href="#/forgot-password">Password dimenticata?</a></p>' +
      '<p class="hint">Non hai un account? <a href="#/register">Registrati</a></p>' +
    '</div>';

  const form = container.querySelector("#loginForm");
  const msg = container.querySelector("#loginMsg");
  const submitBtn = form.querySelector('button[type="submit"]');
  // Round Beta-P3-2: guardia logica locale contro l'invio duplicato — mai un lock globale/di modulo
  // (ogni render di questa pagina crea una closure fresca). e.preventDefault() resta la PRIMISSIMA
  // istruzione per OGNI evento submit, incluso un duplicato: uscire prima la lascerebbe cadere sul
  // comportamento nativo del browser (navigazione/reload). submitBtn.disabled è solo un feedback UX
  // — la correttezza viene da `submitting`, controllata PRIMA di qualunque await.
  let submitting = false;
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    if(submitting) return;
    submitting = true;
    submitBtn.disabled = true;
    try{
      msg.innerHTML = "";
      const email = container.querySelector("#loginEmail").value;
      const password = container.querySelector("#loginPassword").value;
      const result = await ctx.adapter.signIn(email, password);
      if(!result.ok){
        msg.innerHTML = '<p class="errtext">' + escapeHtml(result.error) + "</p>";
        return;
      }
      msg.innerHTML = renderNoticeIfAny(result);
      // Round Beta-P3-3: mai forzare l'utente su /dashboard se ha già lasciato questa pagina — la
      // sessione autenticata è comunque reale e resta (§13 del design: nessun rollback), solo la
      // navigazione di QUESTO vecchio render viene soppressa.
      if(isStale()) return;
      ctx.navigate("/dashboard");
    } finally {
      submitting = false;
      submitBtn.disabled = false;
    }
  });
}
